import { createVolumeAutocompleteFilter } from './common/createVolumeAutocompleteFilter';

export default createVolumeAutocompleteFilter({
  field: 'diskType',
  groupLabel: 'Volume Type',
  mustTypeFirstMessage: 'Start typing volume type',
  defaultQuery: 'gp',
  logPrefix: '[DiskTypeFilter]',
});
